import { render, staticRenderFns } from "./CarModelTable.vue?vue&type=template&id=2d43eef3&scoped=true"
import script from "./CarModelTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CarModelTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CarModelTable.vue?vue&type=style&index=0&id=2d43eef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43eef3",
  null
  
)

export default component.exports